import {
  Choice, Slider, Counter, SECTION_EMOJI, YES_NO_NSP, YES_NO_NSP_BIN,
  buildCommonStartSteps, buildTabacSteps, buildAlcoolSteps, buildMentalSteps, buildRedFlagsStep,
  updateExtra, getExtra,
} from './BilanWidgets';

// Tranche 60-65 ans : focus cardiovasculaire + dépistages + alimentation
export function build6065Steps(config, answers, update) {
  const setEx = (k, v) => updateExtra(answers, update, k, v);
  const gx = (k) => getExtra(answers, k);

  return [
    ...buildCommonStartSteps(config, answers, update),
    ...buildTabacSteps(answers, update),
    ...buildAlcoolSteps(answers, update),
    // Activité physique
    { id: 'activite', emoji: SECTION_EMOJI.activite, title: 'Minutes d\'activité physique par semaine ?', subtitle: "Marche rapide, vélo, natation, jardinage...",
      render: () => <Slider testid="q-act" value={answers.activite_physique_min_sem} onChange={(v) => update({ activite_physique_min_sem: v })}
        min={0} max={420} step={15} unit=" min/sem"
        presets={[
          { value: 0, label: 'Aucune' },
          { value: 60, label: '~1h' },
          { value: 150, label: '~2h30' },
          { value: 300, label: '5h+' },
        ]}
        zones={[
          { color: 'bg-rose-200', label: 'Insuffisant' },
          { color: 'bg-amber-200', label: 'Moyen' },
          { color: 'bg-emerald-200', label: 'Bon' },
        ]} />
    },
    // Alimentation (4 items courts)
    { id: 'ali_fruits', emoji: '🥗', title: 'Portions de fruits et légumes par jour ?',
      render: () => <Slider testid="q-ali-fruits" value={gx('ali_fruits')} onChange={(v) => setEx('ali_fruits', v)} min={0} max={10} step={1} unit=" portions"
        presets={[{ value: 0, label: '0' }, { value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }, { value: 5, label: '5+' }]} />
    },
    { id: 'ali_poisson', emoji: '🐟', title: 'Poisson par semaine ?',
      render: () => <Slider testid="q-ali-poisson" value={gx('ali_poisson')} onChange={(v) => setEx('ali_poisson', v)} min={0} max={14} step={1} unit=" fois/sem"
        presets={[{ value: 0, label: 'Jamais' }, { value: 1, label: '1×' }, { value: 2, label: '2×' }, { value: 3, label: '3×' }, { value: 5, label: '5×+' }]} />
    },
    { id: 'ali_fastfood', emoji: '🍟', title: 'Fast-food / plats industriels par semaine ?',
      render: () => <Slider testid="q-ali-ff" value={gx('ali_fastfood')} onChange={(v) => setEx('ali_fastfood', v)} min={0} max={14} step={1} unit=" fois/sem"
        presets={[{ value: 0, label: 'Jamais' }, { value: 1, label: '1×' }, { value: 2, label: '2×' }, { value: 4, label: '3-5×' }, { value: 7, label: '6×+' }]} />
    },
    { id: 'ali_eau', emoji: '💧', title: 'Verres d\'eau par jour ?',
      render: () => <Slider testid="q-ali-eau" value={gx('ali_eau')} onChange={(v) => setEx('ali_eau', v)} min={0} max={15} step={1} unit=" verres"
        presets={[{ value: 2, label: '<3' }, { value: 4, label: '3-4' }, { value: 6, label: '5-6' }, { value: 8, label: '7-8' }, { value: 10, label: '9+' }]} />
    },

    ...buildMentalSteps(answers, update),

    // Santé cardiovasculaire
    { id: 'cv_tension', emoji: '❤️', title: 'Votre tension artérielle ?',
      render: (a, u, advance) => <Choice testid="q-cv-ta" value={gx('cv_tension')} onChange={(v) => { setEx('cv_tension', v); advance(); }}
        options={[{value:'normal',label:'Normale'},{value:'elevee',label:'Élevée'},{value:'nsp',label:'Je ne sais pas'}]} />
    },
    { id: 'cv_cholesterol', emoji: '🧬', title: 'Bilan cholestérol récent (< 5 ans) ?',
      render: (a, u, advance) => <Choice testid="q-cv-chol" value={gx('cv_cholesterol')} onChange={(v) => { setEx('cv_cholesterol', v); advance(); }}
        options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    { id: 'cv_glycemie', emoji: '🩸', title: 'Glycémie (sucre dans le sang) récente (< 5 ans) ?',
      render: (a, u, advance) => <Choice testid="q-cv-gly" value={gx('cv_glycemie')} onChange={(v) => { setEx('cv_glycemie', v); advance(); }}
        options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },

    // Vaccinations (élargies à cette tranche)
    { id: 'vaccin_dtp', emoji: SECTION_EMOJI.vaccin, title: 'Vaccin DTP à jour ?', subtitle: 'Rappel tous les 20 ans après 25 ans',
      render: (a, u, advance) => <Choice testid="q-vac-dtp" value={answers.vaccin_dtp} onChange={(v) => { update({ vaccin_dtp: v }); advance(); }} options={YES_NO_NSP} />
    },
    { id: 'vaccin_grippe', emoji: SECTION_EMOJI.vaccin, title: 'Grippe cette année ?', subtitle: 'Recommandé chaque automne',
      render: (a, u, advance) => <Choice testid="q-vac-gr" value={answers.vaccin_grippe} onChange={(v) => { update({ vaccin_grippe: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    { id: 'vaccin_covid', emoji: SECTION_EMOJI.vaccin, title: 'COVID (moins d\'un an) ?',
      render: (a, u, advance) => <Choice testid="q-vac-cov" value={answers.vaccin_covid} onChange={(v) => { update({ vaccin_covid: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    { id: 'vaccin_zona', emoji: SECTION_EMOJI.vaccin, title: 'Vaccin zona (recommandé à partir de 65 ans) ?',
      render: (a, u, advance) => <Choice testid="q-vac-zona" value={gx('vaccin_zona')} onChange={(v) => { setEx('vaccin_zona', v); advance(); }} options={YES_NO_NSP} />
    },

    // Dépistages — branching F/H
    ...(answers.sex === 'F' ? [
      { id: 'depistage_mammo', emoji: SECTION_EMOJI.depistage, title: 'Mammographie dépistage organisé (< 2 ans) ?',
        render: (a, u, advance) => <Choice testid="q-dep-m" value={answers.depistage_mammo} onChange={(v) => { update({ depistage_mammo: v }); advance(); }} options={YES_NO_NSP} /> },
      { id: 'depistage_fcu', emoji: SECTION_EMOJI.depistage, title: 'Frottis / test HPV (< 5 ans) ?',
        render: (a, u, advance) => <Choice testid="q-dep-f" value={answers.depistage_fcu} onChange={(v) => { update({ depistage_fcu: v }); advance(); }} options={YES_NO_NSP} /> },
      { id: 'menopause', emoji: '🌸', title: 'Êtes-vous ménopausée ?',
        render: (a, u, advance) => <Choice testid="q-meno" value={gx('menopause')} onChange={(v) => { setEx('menopause', v); advance(); }} options={YES_NO_NSP_BIN} /> },
    ] : []),
    { id: 'depistage_hemoccult', emoji: SECTION_EMOJI.depistage, title: 'Dépistage cancer colorectal (< 2 ans) ?', subtitle: 'Test "Hemoccult"',
      render: (a, u, advance) => <Choice testid="q-dep-h" value={answers.depistage_hemoccult} onChange={(v) => { update({ depistage_hemoccult: v }); advance(); }}
        options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    ...(answers.sex === 'H' ? [
      { id: 'depistage_psa', emoji: SECTION_EMOJI.depistage, title: 'Dosage PSA (prostate) évoqué avec un médecin ?',
        render: (a, u, advance) => <Choice testid="q-dep-p" value={answers.depistage_psa} onChange={(v) => { update({ depistage_psa: v }); advance(); }}
          options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
      ...(answers.tabac === 'current' || answers.tabac === 'former' ? [
        { id: 'depistage_aaa', emoji: SECTION_EMOJI.depistage, title: 'Échographie abdominale (dépistage anévrisme aorte) ?',
          subtitle: 'Recommandée chez les fumeurs/anciens fumeurs 65-75 ans',
          render: (a, u, advance) => <Choice testid="q-dep-aaa" value={gx('depistage_aaa')} onChange={(v) => { setEx('depistage_aaa', v); advance(); }}
            options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
      ] : []),
    ] : []),
    ...buildRedFlagsStep(config, answers, update),
  ];
}
